export const estimateReadTime = (text) => {
  const wordsPerMinute = 150; // average reading speed of an 8th grader

  const startIndex = text.indexOf("<p>");
  const endIndex = text.lastIndexOf("</p>");

  const cleanedText = text
    .slice(startIndex + 3, endIndex)
    .replace(/<[^>]+>/g, "");
  const words = cleanedText.trim().split(/\s+/).length;
  const readTime = Math.ceil(words / wordsPerMinute);

  return readTime;
};
